module.exports = __webpack_public_path__ + "img/blk.4bbd6e61.svg";